import React from 'react';
import { useTranslation } from 'react-i18next';

export function TemplateStateSwitch({
  onChange,
}: {
  onChange: (value: boolean) => void;
}) {
  const [t] = useTranslation(['common', 'admin']);

  return (
    <div className="w-full text-[#53586C]">
      <span className="font-medium">
        {t('activity_status', '活動狀態', { ns: 'admin' })}
      </span>
      <label className="flex items-center relative w-max cursor-pointer select-none mt-4">
        <input
          type="checkbox"
          onChange={(e) => {
            onChange(e.target.checked);
          }}
          className="appearance-none transition-colors cursor-pointer w-14 h-7 rounded-full focus:outline-none bg-gray-400 checked:bg-group-primary text-group-primary checked:bg-none border-0 peer"
        />
        <span className="absolute font-medium text-sm right-2 text-white">
          {t('off', '關')}
        </span>
        <span className="absolute font-medium text-sm left-2 text-white">
          {t('on', '開')}
        </span>
        <span className="w-6 h-6 absolute left-0.5 rounded-full transform transition-transform peer-checked:translate-x-7 bg-gray-200" />
      </label>
    </div>
  );
}
